import cn from 'classnames';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import s from './index.scss';

const Input = ({
    maxLength = 99,
    type,
    disabled = false,
    autoFocus = false,
    tips,
    onActualChange, defaultValue, onBlur, err, onChange, verify, placeholder, addonAfter, value
}) => {
    const [errMsg, setErrMsg] = useState('');
    const [outterError, setOutterError] = useState(err || '');
    const [_value, setValue] = useState(defaultValue || '');
    useEffect(() => {
        if (err) {
            setOutterError(err);
        } else {
            setOutterError('');
        }
    }, [err]);
    return (
        <React.Fragment>
            {tips && <p className={s.tips}>{tips}</p>}
            <div className={s.container}>
                <input
                    maxLength={maxLength}
                    type={type}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    onChange={e => {
                        if (onActualChange) {
                            onActualChange(e.target.value);
                        }
                        if (maxLength)
                            setValue(e.target.value.substr(0, maxLength));
                        else
                            setValue(e.target.value);
                        /*
                        if (verify) {
                            verify(e.target.value);
                            setErrMsg('');
                        } else {
                            setErrMsg('');
                        }*/
                    }}
                    onFocus={() => void 0}
                    onBlur={e => {
                        if (verify) {
                            try {
                                verify(e.target.value);
                                setErrMsg('');
                                onChange(e.target.value);
                                if (onBlur) {
                                    onBlur(e.target.value);
                                }
                            } catch (error) {
                                onChange('');
                                if (onBlur) {
                                    onBlur('');
                                }
                                setErrMsg(error.message);
                            }
                        } else {
                            onChange(e.target.value);
                            if (onBlur) {
                                onBlur(e.target.value);
                            }
                        }
                    }}
                    className={cn(s.input, {[s.hasAddon]: addonAfter})}
                    placeholder={placeholder}
                    value={typeof value === 'undefined' ? _value : value}
                />
                {
                    addonAfter &&
                        (
                            <div
                                className={s.addonArea}
                            >
                                {addonAfter}
                            </div>
                        )
                }
            </div>
            <p
                className={s.error}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: outterError || errMsg || '&nbsp;'
                }}
            />
        </React.Fragment>
    );
};

Input.propTypes = {
    maxLength: PropTypes.number,
    type: PropTypes.string,
    autoFocus: PropTypes.bool,
    tips: PropTypes.string,
    disable: PropTypes.bool,
    onActualChange: PropTypes.func,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onBlur: PropTypes.func,
    err: PropTypes.string,
    onChange: PropTypes.func,
    verify: PropTypes.func,
    placeholder: PropTypes.string,
    addonAfter: PropTypes.any,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export default Input;
